// import _ from 'underscore';
import Backbone from 'backbone';

function getTodayEnd() {
  var end = new Date();
  end.setHours(23, 59, 59, 999);
  return end;
}

function createKey(id) {
  return 'mg_lp_' + id;
}

export var PmlayerModel = Backbone.Model.extend({
  defaults: function () {
    return {
      id: '',
      width: 0,
      height: 0,
      isVisible: false,
      isTodayDismiss: false
    };
  },

  initialize: function () {
    var ckId = createKey(this.get('id'));
    if ($.cookie(ckId) === 'true') {
      this.set('isTodayDismiss', true);
    }
  },

  setVisible: function (status) {
    if (status && this.get('isTodayDismiss')) {
      return;
    }
    this.set('isVisible', status);
  },

  setClose: function () {
    var ckId;
    if (this.get('isTodayDismiss')) {
      ckId = createKey(this.get('id'));
      $.cookie(ckId, true, {
        path: '/',
        expires: getTodayEnd()
      });
    }
    this.set('isVisible', false);
  }
});

export function getValueFromPmlayerDOM(el) {
  var $el = $(el);
  var values = {
    id: $el.data('pmlayerId'),
    width: $el.data('width'),
    height: $el.data('height')
  };
  return values;
}
